import { render, staticRenderFns } from "./TablaTotalSims.vue?vue&type=template&id=6f0265c6&"
import script from "./TablaTotalSims.vue?vue&type=script&lang=ts&"
export * from "./TablaTotalSims.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports